<template>
  <div class="search-container">
    <div class="search-tabs">
      <div
        class="search-tab"
        v-for="tab in searchTabs"
        :key="tab.value"
        :class="{ active: activeValue === tab.value }"
        @click="tabChange(tab.value)"
      >
        <span>{{ tab.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeValue: 'B',
      searchTabs: [
        {
          label:
            this.$l('INDEX.search-tabs_filledUnsubmit') || '已确认补货数量',
          value: 'B',
        },
        { label: this.$l('INDEX.search-tabs_all') || '全部', value: 'A' },
      ],
    }
  },
  methods: {
    tabChange(e) {
      this.activeValue = e
      this.$emit('change', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.search-container {
  .search-tabs {
    display: flex;
    align-items: center;
    .search-tab {
      font-size: 14px;
      line-height: 28px;
      padding: 0px 12px;
      color: #2e2e2e;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      width: max-content;
    }
    .search-tab:hover {
      color: #000;
      border-bottom-color: rgba(0, 0, 0, 0.1);
    }
    .search-tab.active {
      color: #000;
      font-weight: 600;
      border-bottom-color: $color-success;
      .badge {
        font-weight: 600;
      }
    }
  }
}
</style>
